export default function WordCount({ text, suggestedMax }) {
  const trimmed = (text || "").trim();
  const words = trimmed ? trimmed.split(/\s+/).filter(Boolean).length : 0;
  const chars = (text || "").length;
  const over = suggestedMax && words > suggestedMax;
  return (
    <div
      className={`text-xs mt-1 flex justify-between gap-3 ${over ? "text-amber-600" : "text-slate-400"}`}
      data-testid="word-count"
    >
      <span>
        {words} {words === 1 ? "word" : "words"}
        {suggestedMax ? <span className="text-slate-400"> · suggested ≤ {suggestedMax}</span> : null}
      </span>
      <span className="text-slate-300">{chars} chars</span>
    </div>
  );
}
